import { render, staticRenderFns } from "./BuyerCampaignTrafficControl.vue?vue&type=template&id=4d748b7a&scoped=true"
import script from "./BuyerCampaignTrafficControl.vue?vue&type=script&lang=ts"
export * from "./BuyerCampaignTrafficControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d748b7a",
  null
  
)

export default component.exports